import styled from "styled-components";

import color from "../../../../../constants/color";

export const ProductCard = styled.a`
  width: 20.1875rem;
  height: 6.875rem;
  box-shadow: 0px 2px 2px rgba(102, 102, 102, 0.02);
  border-radius: 8px;
  text-decoration: none;

  &:hover {
    img {
      transform: scale(1.03);
    }
  }
`;

export const BoxImg = styled.div`
  width: 100%;
  position: relative;
  border-radius: 8px 8px 0px 0px;
  overflow: hidden;
  height: 60px;

  img {
    width: 100%;
    border-radius: 8px 8px 0px 0px;
    object-fit: cover;
    display: block;
    transition: all 0.3s;
    height: 100%;
  }
`;

export const BoxContent = styled.div`
  border: 1px solid #ececec;
  box-shadow: 0px 2px 2px rgba(102, 102, 102, 0.02);
  border-radius: 0px 0px 8px 8px;
  padding: 8px 8px 0px 16px;
`;

export const PrdTitle = styled.div`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.01em;
  color: #333333;
  margin-bottom: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const Flag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 100%;
  background-color: ${color.White};
  position: absolute;
  top: 16px;
  left: 16px;
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #2d5bff;
  border-radius: 16px;
  position: absolute;
  top: 16px;
  right: 16px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 130%;
  text-align: center;
  color: #ffffff;
  width: 109px;
  height: 24px;
`;
